<script>
import { Line } from 'vue-chartjs'
import { format } from 'date-fns';

export default {
  props: ['responseData'],
  extends: Line,

  computed: {
    currentCustomer() {
        return this.$store.state.customer.info;
    },
  },

  methods: {
      setLineColor(lineIndex) {
          const brandInfo = '#63c2de';
          const brandSuccess = '#4dbd74'
          const brandDanger = '#f86c6b'
          let lineColor = brandInfo;

          if (lineIndex === 1) {
              lineColor = brandSuccess;
          } else if (lineIndex === 2) {
              lineColor = brandDanger;
          }

          return lineColor;
      },

      convertData() {
        let chartData = {
            labels: [],
            datasets: [],
        }
        let datasetsDataNoDiscount = false;
        let datasetsDataExVat = false;
        let noVat = this.currentCustomer.vat_number;
        let datasetsData = {
            label: 'Total amount',
            backgroundColor: 'rgba(160, 81, 149, 0.25)',
            borderColor: 'rgb(160, 81, 149)',
            pointHoverBackgroundColor: '#ff7f1f',
            data: [],
        }
        let discountAmounts = false;
        if (noVat) {
            discountAmounts = this.responseData.filter(item => (item.amount_without_discount_in_cents) - (item.amount_in_cents_ex_vat) > 0 && item.amount_in_cents_ex_vat != null);
        } else {
            discountAmounts = this.responseData.filter(item => (item.amount_without_discount_in_cents) - (item.amount_in_cents) > 0 && item.amount_in_cents != null);
        }
        if (discountAmounts.length > 1) {
            datasetsDataNoDiscount = {
                label: 'Total amount excl. discount',
                backgroundColor: 'rgba(37, 179, 184, 0.25)',
                borderColor: '#25b3b8',
                pointHoverBackgroundColor: '#25b3b8',
                data: [],
            }
        }

          this.responseData.forEach((item, i) => {
            // if (item.amount_in_cents >= 0) {
                chartData.labels.push(format(new Date(item.created_at), 'MMM dd, yyyy'))
                if (noVat) {
                    datasetsData.data.push(item.amount_in_cents / 100)
                } else {
                    datasetsData.data.push(item.amount_in_cents_ex_vat / 100)
                }
                if (datasetsDataNoDiscount) {
                    datasetsDataNoDiscount.data.push(item.amount_without_discount_in_cents / 100)
                }
            // }
            //   let lineColor = this.setLineColor(i)
            //   let data = {
            //       label: item.metric.label_beta_kubernetes_io_instance_type + ' - ' + item.metric.name,
            //       backgroundColor: convertHex(lineColor, 10),
            //       borderColor: lineColor,
            //       pointHoverBackgroundColor: '#ff7f1f',
            //       data: [],
            //   }
            //   item.values.forEach((item, i) => {
            //       console.log('value item: ', item[1])
            //       data.data.push(item[1])
            //   })
            //   chartData.datasets.push(data)

          });
          if (datasetsData) {
            chartData.datasets.push(datasetsData)
          }
          if (datasetsDataExVat) {
              chartData.datasets.push(datasetsDataExVat)
          }
          if (datasetsDataNoDiscount) {
              chartData.datasets.push(datasetsDataNoDiscount)
          }

          let chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            // tooltips: {
            //     enabled: true,
            //     callbacks: {
            //         label: ((tooltipItems, data) => {
            //             let index = tooltipItems.datasetIndex;
            //             return '€' + tooltipItems.value;
            //         })
            //     }
            // },

            scales: {
                // xAxes: [{
                //     position: 'bottom',
                //     min: 0,  // My use case requires starting at zero
                //     beginAtZero: true,
                //     autoSkip: true,
                //     ticks: {
                //         callback: function(value, index, values) {
                //             console.log('value, ' , value);
                //             console.log('index, ' , index);
                //             console.log('values, ' , values);
                //             // Make sure a tick is not a fractional value
                //             if (values[index + 1] !== value) {
                //                 return value;
                //             }
                //         }
                //     }
                // }],

                // xAxes: {
                //     autoSkip: false,
                //     grid: {
                //       tickColor: chartData.labels.map((l, i) => i % 3 ? null : 'lightgray')
                //     },
                //     ticks: {
                //       callback: (t, i) => i % 3 ? '' : labels[i]
                //     },
                // },
                // yAxes: {
                //     beginAtZero: true
                // },

                xAxes: [{
                  ticks: {
                      // Make labels vertical
                      // https://stackoverflow.com/questions/28031873/make-x-label-horizontal-in-chartjs
                      // minRotation: 90,

                      // Limit number of labels
                      // https://stackoverflow.com/questions/22064577/limit-labels-number-on-chartjs-line-chart
                      autoSkip: true,
                      maxTicksLimit: 20
                  }
                }]
            }
          }
          this.renderChart(chartData, chartOptions);
      },
  },


  mounted() {
      this.convertData();
  },
}
</script>
